import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Logger} from "dce-logger";
import {I18n} from "../../../../dce-i18n/lib";
import {InternalDropzoneOptions} from "./internal/InternalDropzoneOptions";
import DropzoneLoader from "./internal/DropzoneLoader";

interface DropzoneMultiFileProps {
    label: string;
    fieldId: string;
    uploadUrl: string;
    accept?: string;
    maxFileSize?: number;
}
//
// async function importDropzone() {
//
//     //import * as Dropzone from "dropzone";
//     let Dropzone = ;
//
//     //Dropzone.autoDiscover = false;
//
//     console.log(Dropzone);
//
//     return Dropzone;
// }



@Dce("DropzoneMultiFile")
export default class DropzoneMultiFile extends DceComponent<DropzoneMultiFileProps> {

    private logger = Logger.of("DropzoneFile");

    private block: JQuery<HTMLElement>;
    private field: JQuery<HTMLElement>;
    private dropzone: Dropzone;

    constructor(elem: DceHTMLElement, props: DropzoneMultiFileProps) {
        super(elem, props);
        this.logger.debug("Init S");

        this.block = $(this.elem);

        this.field = this.block.find('#' + this.props.fieldId);

        let previewTpl = this.block.find('.upload-item').html()
        let previewCont = this.block.find('.upload-list')[0];

        DropzoneLoader.load().then(Dropzone_ => {

            let options:InternalDropzoneOptions = {
                url: this.props.uploadUrl,
                createImageThumbnails: false,
                previewTemplate: previewTpl,
                previewsContainer: previewCont,
                hiddenInputContainer: this.elem,
                uploadMultiple: false,
                withCredentials: true,

                //dzielenie na kawałki po 2MB
                chunking: true
            };

            if (I18n.has('dropzoneI18N')) {
                options = {
                    ...options,
                    ...I18n.get('dropzoneI18N')
                }
            }

            if (this.props.accept) {
                options.acceptedFiles = this.props.accept;
            }

            if (this.props.maxFileSize) {
                options.maxFilesize = this.props.maxFileSize;
            }

            // @ts-ignore
            this.dropzone = new Dropzone_(this.block.find('.dropzone')[0], options);

            this.dropzone.on('complete', file => {
                this.uploadComplete(file);
            });
        });


        // import(/* webpackChunkName: "dropzone" */ 'dropzone').then(DropzoneModule => {
        //
        //     console.log("Dropzone in then", DropzoneModule);
        //
        //     let Dropzone_ = (DropzoneModule as any).default as Dropzone;
        //
        //
        //
        // })


        this.block.on('click', '[data-remove=1]', e => {
            $(e.target).closest('.file-item').remove();
            this.updateInputIndexes();
        });


    }

    private updateInputIndexes(){

        var inputName = this.block.attr('name');

        var items = this.block.find('.file-row .file-item');

        if(items.length > 0) {

            this.block.find('.file-row .empty-file-item').remove();

            items.each(function (index) {
                $(this).find('input[type=hidden]').attr(
                    'name', inputName + '[' + index + ']'
                );
            });
        }else{

            this.block.find('.empty-file-item').clone().appendTo(
                this.block.find('.file-row')
            ).show();

        }

    }

    private uploadComplete(file:Dropzone.DropzoneFile){

        if(file.status == 'success'){

            var jsonResp = JSON.parse(file.xhr.response);

            if(jsonResp.hasOwnProperty('response')){

                var inputName = this.block.attr('name');

                $(file.previewElement).slideUp(200);

                this.field.val(jsonResp['data']['id']);

                var form = '<input type="hidden" name="' + inputName + '[0]" value="' + jsonResp['data']['id'] +'"/>';

                var html = jsonResp['response'].replace('{{form}}', form);
                this.block.find('.file-row').append(html);

                this.updateInputIndexes();

            }else{

                setTimeout(function () {
                    $(file.previewElement).slideUp(200);
                }, 800);

            }

        }
    }

}
